import React from 'react'
import AlertMessagge from '../../../components/molecules/alertMessagge/alertMessagge'
import Button from '../../../shared/components/atoms/Button/Button'
import SampleIcon from '../../../shared/assets/images/image-samples-complete.png'
import './modalAlert.scss'
import LayoutModal from '../../../shared/components/organisms/layoutModal/layout-modal'

const ModalAlert = ({ hideAction, actionAlert }) => {
	return (
		<LayoutModal onClose={hideAction}>
			<div className='f-alert-wrapper'>
				<div className='f-card-modal-head'>
					<span className='f-card-modal-head-icon' onClick={hideAction}>
						X
					</span>
				</div>
				<AlertMessagge
					icon={<img src={SampleIcon} alt='sample-icon' />}
					messagge='¡Tu muestra está completa!'
					description='No puedes agregar más productos.'
					type='primary'
					button={
						<Button
							type='button'
							text='SOLICITAR MI MUESTRA'
							onClickAction={() => {
								hideAction()
								actionAlert()
							}}
							classname='f-button f-button--primary'
						/>
					}
				/>
			</div>
		</LayoutModal>
	)
}

export default ModalAlert
